<template>
    <AppPage title="Página não encontrada" subtitle="a página que você está tentando acessar não existe">
        <router-link class="button is-primary" :to="{name: 'home'}" slot="actions">Voltar ao início</router-link>
    </AppPage>
</template>

<script>
    import AppPage from "../components/AppPage";
    export default {
        name: "pageNotFound",
        components: {
            AppPage
        }
    }
</script>